import * as Papa from "papaparse";

import { Component } from "react";
import { FormattedMessage, injectIntl} from "react-intl";
import { OPTION_DELIMITER, OTHER_ANSWER_SUFFIX } from "../../../../../common/constant";

import { detect } from "jschardet";
import _ from "lodash";
import { parseImportedSurveyDate } from "../../../../../utils/SurveyDateUtils";
import PropTypes from "prop-types";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReactMarkdown from 'react-markdown';

const initialState = {
  message: {},
  confirmationAllowed: false,
  importData: null,
  importInProgress: false
};

class CsvFileUploadModalDialog extends Component {
  constructor(props) {
    super(props);
    this.handleConfirmation = this.handleConfirmation.bind(this);
    this.handleConfirmationOverwrite = this.handleConfirmationOverwrite.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleClearMessage = this.handleClearMessage.bind(this);
    this.state = initialState;
  }

  handleClearMessage() {
    this.setState({ message: null });
  }

  handleConfirmation(event) {
    event.preventDefault();

    const { importRows, question, answer } = this.props;

    if (this.state.importInProgress) {
      return;
    }

    this.setState({ importInProgress: true });

    importRows(question, answer, this.state.importData, false);

    this.setState(initialState);
    this.props.onClose();
  }

  handleConfirmationOverwrite(event) {
    event.preventDefault();

    const { importRows, question, answer } = this.props;

    if (this.state.importInProgress) {
      return;
    }

    this.setState({ importInProgress: true });

    importRows(question, answer, this.state.importData, true);

    this.setState(initialState);
    this.props.onClose();
  }

  handleCancel(event) {
    event.preventDefault();

    this.setState(initialState);
    this.props.onClose();
  }

  handleFileChange(event) {
    event.preventDefault();

    const { question, intl } = this.props;

    this.handleClearMessage();

    let file = event.target.files[0];

    let config;
    let charsetMatch;
    let fileReader = new FileReader();
    fileReader.onload = function () {
      let array = new Uint8Array(fileReader.result);
      let string = "";
      for (let i = 0; i < array.length; ++i) {
        string += String.fromCharCode(array[i]);
      }
      charsetMatch = detect(string);
      if (charsetMatch && charsetMatch.encoding) {
        config.encoding = charsetMatch.encoding;
        console.log("encoding of file:" + charsetMatch.encoding);
      }

      Papa.parse(file, config);
    };
    fileReader.readAsArrayBuffer(file);

    config = {
      header: true,
      skipEmptyLines: true,
      delimiter: ";",
      error: (error, file) => {
        this.setState({
          message: {
            severity: "danger",
            value: error.error
          },
          confirmationAllowed: false
        });
      },
      complete: (results, file) => {
        if (results.errors.length !== 0) {
          this.setState({
            message: {
              severity: "danger",
              value: results.errors
            },
            confirmationAllowed: false
          });
        } else {
          // Check results.data vs. question (template)

          let valid = true;
          let invalidColumns = [];
          let resultData = [];
          let invalidOptions = [];
          let parseErrorMessage = "user.surveyView.table.uploadCSV.values.parseError";

          let firstRow = results.data[0];
          let importColumns = Object.keys(firstRow).filter(function (key) {
            return key.trim().length > 0;
          });
          let templateColumns = question.columns;
          let rowCount = 0;
          results.data.forEach((dataRow) => {
            rowCount++;
            let isRowEmpty = true;
            importColumns.forEach((importColumn) => {
              let found = false;
              let text1 = importColumn.trim(); //TODO: add logic for multiple values
              let multipleSelect = false;
              let multipleValue;
              if (text1.includes(OPTION_DELIMITER)) {
                let temp = text1.split(OPTION_DELIMITER);
                text1 = temp[0].trim();
                multipleSelect = true;
                multipleValue = temp[1].trim();
              }
              templateColumns.forEach((templateColumn) => {
                let text2 = templateColumn.text.trim();
                if (text1 === text2) {
                  found = true;
                  let dataValue = dataRow[importColumn].trim();
                  if (dataValue) {
                    isRowEmpty = false;
                    let isColumnValid = true;
                    if (
                        templateColumn.type === "Checkbox" && multipleSelect
                      ) {
                        let foundOption = false;
                        templateColumn.choices.forEach((choice) => {
                          let choiceText = choice.text.trim();
                          if (choiceText === multipleValue && ["Ja","Nein",""].includes(dataValue)) {
                            foundOption = true;
                          }
                        });
                        if (
                          !foundOption &&
                          dataValue &&
                          importColumn.includes(OTHER_ANSWER_SUFFIX) &&
                          templateColumn.hasOther
                        ) {
                          foundOption = true;
                        }
                        isColumnValid = foundOption;
                      } else if (
                      templateColumn.type === "Radio" ||
                      templateColumn.type === "Dropdown" ||
                      templateColumn.type === "Checkbox" ||
                      templateColumn.type === "predefinedList"
                    ) {
                      let foundOption = false;
                      templateColumn.choices.forEach((choice) => {
                        let choiceText = choice.text.trim();
                        if (choiceText === dataValue) {
                          foundOption = true;
                        } else if (templateColumn.hasOther && dataValue === "Sonstiges") {
                          foundOption = true;
                        }
                      });
                      if (
                        !foundOption &&
                        dataValue &&
                        importColumn.includes(OTHER_ANSWER_SUFFIX) &&
                        templateColumn.hasOther
                      ) {
                        foundOption = true;
                      }
                      isColumnValid = foundOption;
                    } else if (templateColumn.type === "Number") {
                      isColumnValid = !isNaN(dataValue.replace(",", "."));
                    } else if (templateColumn.type === "Date") {
                      isColumnValid = parseImportedSurveyDate(dataValue, question.dateFormat).isValid();
                    }
                    if (!isColumnValid) {
                      invalidOptions.push(
                        intl.formatMessage(
                          { id: parseErrorMessage },
                          {
                            rowCount: rowCount,
                            importColumn: importColumn,
                            importValue: dataValue
                          }
                        )
                      );
                      valid = false;
                    }
                  }
                } else if (text1 === text2 + OTHER_ANSWER_SUFFIX && templateColumn.hasOther) {
                  found = true;
                }
              });
              if (!found) {
                let message = intl.formatMessage(
                  { id: "user.surveyView.table.uploadCSV.columns.parseError" },
                  { importValue: importColumn }
                );
                if (invalidColumns.indexOf(message) < 0) {
                  invalidColumns.push(message);
                }
                valid = false;
              }
            });
            if (!isRowEmpty) {
              resultData.push(dataRow);
            }
          });

          if (valid) {
            this.setState({
              message: {
                severity: "success",
                value: [
                  {
                    message: intl.formatMessage(
                      { id: "user.surveyView.table.uploadCSV.success" },
                      { rowCount: resultData.length }
                    )
                  }
                ]
              },
              confirmationAllowed: true,
              importData: resultData
            });
          } else if (invalidOptions.length > 0) {
            let messages = [];
            messages.push({ message: intl.formatMessage({ id: "user.surveyView.table.uploadCSV.parseError" }) });
            if (invalidColumns.length > 0) {
              invalidColumns.forEach((invalidColumn) => {
                messages.push({ message: "- " + invalidColumn });
              });
              messages.push({ message: " " });
            }
            if (invalidOptions.length > 0) {
              invalidOptions.forEach((invalidOption) => {
                messages.push({ message: "- " + invalidOption });
              });
              messages.push({ message: " " });
            }
            this.setState({
              message: {
                severity: "danger",
                value: messages
              },
              confirmationAllowed: false,
              importData: null
            });
          } else if (invalidColumns.length > 0) {
            let messages = [];
            messages.push({ message: intl.formatMessage({ id: "user.surveyView.table.uploadCSV.parseWarning" }) });
            if (invalidColumns.length > 0) {
              invalidColumns.forEach((invalidColumn) => {
                messages.push({ message: "- " + invalidColumn });
              });
              messages.push({ message: " " });
            }

            this.setState({
              message: {
                severity: "warning",
                value: messages
              },
              confirmationAllowed: true,
              importData: resultData
            });
          }
        }
      }
    };
  }

  render() {
    let { show, intl } = this.props;
    const { confirmationAllowed, importInProgress } = this.state;

    const infoMessage = intl.formatMessage({ id: 'user.surveyView.table.uploadCSV.hint' });

    let message;

    if (!_.isEmpty(this.state.message)) {
      message = (
        <Alert onDismiss={this.handleClearMessage} variant={this.state.message.severity}>
          <ul style={{ listStyleType: "none" }}>
            {this.state.message.value.map((message, index) => {
              return <li key={index}><ReactMarkdown>{message.message}</ReactMarkdown></li>;
            })}
          </ul>
        </Alert>
      );
    } else {
      message = null;
    }

    return (
      <Modal show={show} enforceFocus autoFocus>
        <form onSubmit={this.handleConfirmation}>
          <Modal.Body>
            <Alert variant="info">
              <p>
                <ReactMarkdown>{infoMessage}</ReactMarkdown>
              </p>
            </Alert>
            <div className="dynamic-table-file-upload">
              {message}
              <input className="fileInput" type="file" onChange={this.handleFileChange} accept="text/csv" />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant={"default"} className="button--grey" onClick={this.handleCancel} disabled={importInProgress}>
              <FormattedMessage id="confirmDialog.cancel" />
            </Button>
            <Button
              variant={"default"}
              className="button--grey"
              onClick={this.handleConfirmation}
              type="button"
              disabled={!confirmationAllowed || importInProgress}
            >
              <FormattedMessage id="user.surveyView.table.uploadCSV.append" />
            </Button>
            <Button
              variant={"default"}
              className="button--grey"
              onClick={this.handleConfirmationOverwrite}
              type="button"
              disabled={!confirmationAllowed || importInProgress}
            >
              <FormattedMessage id="user.surveyView.table.uploadCSV.overwrite" />
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

CsvFileUploadModalDialog.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  importRows: PropTypes.func.isRequired,
  question: PropTypes.object.isRequired,
  answer: PropTypes.object.isRequired
};

export default injectIntl(CsvFileUploadModalDialog);
